"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FirstDayOfWeek = void 0;

/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
var FirstDayOfWeek;
exports.FirstDayOfWeek = FirstDayOfWeek;

(function (FirstDayOfWeek) {
  FirstDayOfWeek[FirstDayOfWeek["Sunday"] = 0] = "Sunday";
  FirstDayOfWeek[FirstDayOfWeek["Monday"] = 1] = "Monday";
  FirstDayOfWeek[FirstDayOfWeek["Tuesday"] = 2] = "Tuesday";
  FirstDayOfWeek[FirstDayOfWeek["Wednesday"] = 3] = "Wednesday";
  FirstDayOfWeek[FirstDayOfWeek["Thursday"] = 4] = "Thursday";
  FirstDayOfWeek[FirstDayOfWeek["Friday"] = 5] = "Friday";
  FirstDayOfWeek[FirstDayOfWeek["Saturday"] = 6] = "Saturday";
})(FirstDayOfWeek || (exports.FirstDayOfWeek = FirstDayOfWeek = {}));